import { createBaseDatastreamDtoSchema } from './create-base-datastream-dto-schema';

/**
 * The base schema for Datastream DTOs.
 *
 * This constant is created using the `createBaseDatastreamDtoSchema` factory function,
 * which defines the foundational structure and validation rules for Datastream Data Transfer Objects (DTOs).
 *
 * @see createBaseDatastreamDtoSchema
 */
export const BaseDatastreamDtoSchema = createBaseDatastreamDtoSchema();
